import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { DocumentDashboardService } from "../../_api/services/document-dashboard.service";
import { LanguageService } from "../../../../shared/services/language.service";
import { Router } from '@angular/router';
import { DocumentQueueService } from "../../_api/services/document-queue.service";
import { BasicSearchComponent } from '../../document-queue/basic-search/basic-search.component';
import { DocumentOperatorSearchDetailComponent } from '../document-operator-search-detail/document-operator-search-detail.component';

let self: DocumentOperatorDashboardComponent = null;

@Component({
  selector: 'app-document-operator-dashboard',
  templateUrl: './document-operator-dashboard.component.html',
  styleUrls: ['./document-operator-dashboard.component.css']
})
export class DocumentOperatorDashboardComponent implements OnInit {

  @ViewChild(BasicSearchComponent, { static: false }) basicSearchComponent: BasicSearchComponent;
  @ViewChild(DocumentOperatorSearchDetailComponent, { static: false }) documentOperatorSearchDetailComponent: DocumentOperatorSearchDetailComponent;

  constructor(private documentQueueService: DocumentQueueService,
    private documentDashboardService: DocumentDashboardService,
    public languageService: LanguageService,
    public router: Router) {
    self = this;
  }

  @Input() parameters = null;

  documentTypes: DocumentType[];
  documentCategories: any;
  documentTypeSearchValue: string = "";
  documentCategorySearchValue: string = "";
  resourceId: number;
  equipmentId: number;
  departmentId: number;
  listOfAffiliatedDocuments: any;
  listOfFavoriteDocuments: any;
  listOfSearchResults: any;
  isLoading: boolean = false;
  tabDataSource = [{ id: -1, index: 0, disabled: false, title: this.languageService.LNG('Label.Dashboard') }];
  tabSelectedIndex: number = 0;
  tabFromDashBoard = 0;

  ngOnInit(): void {
    self.setLookups().then(r => {
    });

    self.tabDataSource.push({ id: -1, index: 1, disabled: false, title: this.languageService.LNG('Label.Favorites') });
    self.tabDataSource.push({ id: -1, index: 2, disabled: true, title: this.languageService.LNG('Label.Search') });
  }

  public labels = {
    lastUsed: this.languageService.LNG("Label.LastUsed"),
    favorites: this.languageService.LNG("Label.Favorites"),
    changedLast: this.languageService.LNG("Label.ChangesLastNDays"),
    comments: this.languageService.LNG("Label.Comments"),
    addNew: this.languageService.LNG("Label.Add"),
    new: this.languageService.LNG('Label.New'),
    affiliation: this.languageService.LNG('Label.Affiliation'),
    close: this.languageService.LNG('Label.Close'),
    search: this.languageService.LNG('Label.Search'),
    searchResult: this.languageService.LNG('Label.SearchResult'),
    searchParameters: this.languageService.LNG('Label.SearchParameters'),
    clear: this.languageService.LNG('Label.clear'),
    Name: this.languageService.LNG('Label.Name'),
    Type: this.languageService.LNG('Label.Type'),
    Category: this.languageService.LNG('Label.Category'),
    Number: this.languageService.LNG('Label.DocumentNumber')
  }

  public async setLookups() {
    this.isLoading = true;
    try {
      self.listOfAffiliatedDocuments = await self.documentDashboardService.getListAffiliatedDocuments(self.parameters).toPromise();
      self.listOfFavoriteDocuments = await self.documentDashboardService.getListOfFavoriteDocuments().toPromise();
      self.documentTypes = await self.documentQueueService.getTypes(self.parameters.SessionId).toPromise();
      self.documentCategories = await self.documentQueueService.getCategories().toPromise();
    } catch (e) {
      alert(e.error);
    }
    this.isLoading = false;
  }

  onRowPrepared(e) {
    if (e.rowType !== 'header')
      e.rowElement.style.height = "75px";
  }

  sortByName(rowData) {
    return rowData.Name;
  }

  public OnTabSelectionChanged(e) {
    if (e.addedItems[0].index == 0) {
      self.setLookups().then(r => {
      });
    }
  }

  public clickOnDocument(document: any) {
    for (let i = 0; i < self.tabDataSource.length; i++) {
      let tab = self.tabDataSource[i];
      if (document.data.DocumentId === tab.id) {
        self.tabSelectedIndex = i;
        return;
      }
    }
    self.tabDataSource.push({ id: document.data.DocumentId, index: self.tabDataSource.length, disabled: false, title: document.data.Name || document.selectedRowsData.DocumentName || 'No title found' });

    self.tabSelectedIndex = self.tabDataSource.length - 1;
  }

  public async onSearchClick() {
    let filterData = {
      typeId: this.basicSearchComponent.documentTypeSearchValue !== '' ? this.basicSearchComponent.documentTypeSearchValue : -1,
      categoryId: this.basicSearchComponent.documentCategorySearchValue !== '' ? this.basicSearchComponent.documentCategorySearchValue : -1,
      freeSearch: this.basicSearchComponent.freeSearchValue
    };
  }

  public async onClearSearchClick() {
    this.basicSearchComponent.documentTypeSearchValue = "";
    this.basicSearchComponent.documentCategorySearchValue = "";
    this.basicSearchComponent.freeSearchValue = "";
  }

  async onTitleClick(e) {
    self.tabSelectedIndex = e.itemIndex;
    if (e.itemIndex === 0) {
      self.tabFromDashBoard = 0;
      self.listOfAffiliatedDocuments = await self.documentDashboardService.getListAffiliatedDocuments(self.parameters).toPromise();
    }
    else if (e.itemIndex === 1) {
      self.tabFromDashBoard = 1;
      self.listOfFavoriteDocuments = await self.documentDashboardService.getListOfFavoriteDocuments().toPromise();
    }
    else if (e.itemIndex === 2) {
      self.tabFromDashBoard = 2;
    }
  }

  onCloseCard() {
    self.tabDataSource.splice(self.tabSelectedIndex, 1);

    self.tabDataSource.filter(tds => tds.index > self.tabSelectedIndex).forEach(tds => tds.index -= 1);
    if (self.tabDataSource.length === 3) { self.tabFromDashBoard < 3 ? self.tabSelectedIndex = self.tabFromDashBoard : self.tabSelectedIndex = (self.tabSelectedIndex - 1 < self.tabDataSource.length - 1) ? self.tabSelectedIndex : self.tabDataSource.length - 1; return; }
    self.tabSelectedIndex = (self.tabSelectedIndex - 1 < self.tabDataSource.length - 1) ? self.tabSelectedIndex : self.tabDataSource.length - 1;
  }

  openTab(event: any) {
    for (let i = 0; i < self.tabDataSource.length; i++) {
      let tab = self.tabDataSource[i];
      if (event.selectedRowsData[0].DocumentDetails.line1 === tab.id) {
        self.tabSelectedIndex = i;
        return;
      }
    }

    self.tabDataSource.push({ id: event.selectedRowsData[0].DocumentDetails.line1, index: self.tabDataSource.length, disabled: false, title: event.selectedRowsData[0].DocumentDetails.line2 || 'No title found' });

    self.tabSelectedIndex = self.tabDataSource.length - 1;
  }
}
